"use client";
import { AppImage } from "@/src/components/NextImage";
import { cn, transformIpfs } from "utils";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { useEffect, useRef, useState } from "react";
import { ospThemes } from "@ospweb/sdk-ui";
import { useSnapshot } from "valtio";
import { useShellRouter } from "@/src/hooks";
import { ExtensionProfileButtonProps } from "./types";
import Translations from "@translate/components/Menu/ExtensionProfileButton";
import { I18nUtil } from "@utils";
import { rootStore } from "@store";
// import { useCreateProfileModalProvider } from "@hooks";
import { ROUTER_PATH } from "@/src/config";

const I18n = I18nUtil.createScoped(Translations);

export const ExtensionProfileButton = (props: ExtensionProfileButtonProps) => {
  const {
    avatar,
    logout,
    avatarClassName,
    buttonClassName,
    containerClassName,
    menuClassName,
    menuBtnClassName,
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const userSnapshot = useSnapshot(rootStore.user);
  const popRef = useRef<HTMLDivElement>(null);
  const popTriggerRef = useRef<HTMLButtonElement>(null);
  // const { open } = useCreateProfileModalProvider();
  const router = useShellRouter();

  useEffect(() => {
    // 确保只在客户端执行
    if (typeof typeof window?.document === "undefined") {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (
        popRef.current &&
        !popRef.current.contains(event.target as Node) &&
        !popTriggerRef?.current?.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={cn("relative flex", containerClassName)}>
      <button
        aria-label="Extension Profile Button"
        data-openreplay-label="Extension Profile Button Button"
        id="btn-extension-profile-button"
        ref={popTriggerRef}
        className={cn(
          "flex flex-row items-center rounded-full z-1000 p-[2px] hover:bg-background_white_overlay10",
          buttonClassName,
        )}
        onClick={() => {
          setIsMenuOpen(!isMenuOpen);
        }}
      >
        <AppImage
          className={cn(
            "border-1px border-background_white_overlay10  hover:border-transparent rounded-full",
            avatarClassName,
          )}
          src={transformIpfs(
            avatar ?? "/assets/images/ic_no_profile_avatar.svg",
          )}
          alt={"userAvatar"}
          width={28}
          height={28}
        />
      </button>
      {isMenuOpen && (
        <div
          ref={popRef}
          className={cn(
            "absolute flex flex-col py-16px justify-items-center items-center right-[-50px] w-[150px] md:w-[200px] md:right-[-70px] h-auto z-900 rounded-12px bg-background_solid_tertiary border-[0.5px] border-background_white_overlay20",
            menuClassName ? menuClassName : "top-36px",
            userSnapshot.profileState === "noProfile"
              ? "top-[-60px]"
              : "top-[-8px]",
          )}
        >
          {userSnapshot.profileState === "noProfile" ? (
            <>
              <button
                aria-label="Extension Profile Button"
                data-openreplay-label="Extension Profile Button Button"
                id="btn-extension-profile-button-2"
                className={cn(
                  "flex flex-row items-center gap-4px w-full ml-[25px] md:ml-0 md:w-168px h-20px",
                  menuBtnClassName,
                )}
                onClick={() => {
                  // open?.();
                  setIsMenuOpen(false);
                }}
              >
                <OspIcons
                  name="user"
                  size={16}
                  color={ospThemes.colors.content_primary}
                />
                <span className="body_m text-content_primary">
                  {I18n.t("Create Profile")}
                </span>
              </button>
              <div className="h-1px w-126px md:w-168px bg-background_white_overlay20 mt-16px mb-16px" />
            </>
          ) : undefined}
          <button
            aria-label="Extension Profile Button"
            data-openreplay-label="Extension Profile Button Button"
            id="btn-extension-profile-button-3"
            className={cn(
              "flex flex-row items-center gap-4px w-full ml-[20px] md:ml-0 md:w-168px h-20px",
              menuBtnClassName,
            )}
            onClick={async () => {
              await logout?.();
              setIsMenuOpen(false);
              router.push(ROUTER_PATH.HOME);
            }}
          >
            <OspIcons
              name="logout-left"
              size={16}
              color={ospThemes.colors.content_primary}
            />
            <span className="body_m text-content_primary">
              {I18n.t("logout")}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};
